import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { environment } from "../../environments/environments";
// import "./CultureReligion.css";
import "../CultureReligion/CultureReligion.css";
import bgImage from "../../assets/images/brown-background.jpg";

const CultureReligion = () => {
  const navigate = useNavigate();
  const cultural_background = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    religious_belief: Yup.string().required("Please answer this question"),
    cultural_background: Yup.string().required("Please answer this question"),
  });

  const handleContinue = async (values) => {
    setIsLoading(true);
    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const userId = parsedUserData?.id || parsedUserData?._id;

      const dataToSend = {
        user_id: userId,
        cultural_background: values.cultural_background,
        religious_belief: values.religious_belief,
        profile_completion_status: "interest",
      };
      console.log("dataToSend", dataToSend);

      const response = await axios.post(
        `${environment.baseURL}/updateuser`,
        dataToSend
      );
      console.log("response in CultureReligion ", response);

      if (response?.data?.success) {
        alert(response.data.message);
        navigate("/Interest");
      } else {
        alert(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="mainContainer"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="culture-container">
        <Formik
          initialValues={{ religious_belief: "", cultural_background: "" }}
          validationSchema={validationSchema}
          onSubmit={handleContinue}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form className="culture-form" onSubmit={handleSubmit}>
              <div>
                <h1 className="headingText">Culture and Belief</h1>
              </div>
              <div className="cultureinput-group">
                <h2>What are your religious beliefs?</h2>
                <textarea
                  placeholder="Please answer in religious brief"
                  className="text-input"
                  onChange={handleChange("religious_belief")}
                  onBlur={handleBlur("religious_belief")}
                  value={values.religious_belief}
                  rows="4"
                />
                {touched.religious_belief && errors.religious_belief && (
                  <p className="error-text">{errors.religious_belief}</p>
                )}
              </div>

              <div className="cultureinput-group">
                <h2>What are your cultural beliefs?</h2>
                <textarea
                  ref={cultural_background}
                  placeholder="Please answer in cultural brief"
                  className="text-input"
                  onChange={handleChange("cultural_background")}
                  onBlur={handleBlur("cultural_background")}
                  value={values.cultural_background}
                  rows="4"
                />
                {touched.cultural_background && errors.cultural_background && (
                  <p className="error-text">{errors.cultural_background}</p>
                )}
              </div>

              <button
                type="submit"
                className="continue-btn"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Continue"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CultureReligion;
